import { Suspense, lazy, useEffect } from "react";
import { Helmet } from "react-helmet";
import ErrorBoundary from "./ErrorBoundary";
import { persistor, store } from "./store";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import CustomLoader from "./Components/CustomLoader";
import Toast from "./Constant/Toast";

function App() {
  const AppRouter = lazy(() => import("./Routes"));

  // Function to handle visibility change
  const handleVisibilityChange = () => {
    if (document.hidden) {
      document.title = "Please come back !";
    } else {
      document.title = "Digi Smart Disc";
    }
  };

  window.addEventListener("error", (e) => {
    if (
      e.message ===
        "ResizeObserver loop completed with undelivered notifications." ||
      e.message === "ResizeObserver loop limit exceeded"
    ) {
      e.stopImmediatePropagation();
    }
  });

  useEffect(() => {
    const handleOnline = () => {
      Toast("s", "Internet connection restored!", "top-center");
    };

    const handleOffline = () => {
      Toast("w", "Internet connection lost!", "top-center");
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);
    window.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
      window.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Digi Smart Disc</title>
        <link
          rel="canonical"
          href="https://master.d2o68iaitamvio.amplifyapp.com/static/media/logo.10efa6fd99c33cf57773.png"
        />
        <meta
          property="og:image"
          content="https://master.d2o68iaitamvio.amplifyapp.com/static/media/logo.10efa6fd99c33cf57773.png"
        />
        <meta name="description" content="Digi Smart Disc" />
      </Helmet>
      <Provider store={store}>
        <PersistGate persistor={persistor}>
          <Suspense fallback={<CustomLoader />}>
            <ErrorBoundary>
              <AppRouter />
            </ErrorBoundary>
          </Suspense>
        </PersistGate>
      </Provider>
    </>
  );
}

export default App;
